(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('centralizedPageHeader', {
            templateUrl: 'app/components/centralized-page-header/centralized-page-header.html',
            controller: centralizedPageHeaderController,
            bindings: {
                name: '@',
                description: '@'
            }
        });

    /** @ngInject */
    function centralizedPageHeaderController() {
    }
})();
